import GenericEntityService from '../GenericEntityService';
export class LayerService extends GenericEntityService {
    constructor(opts = {
        basePath: '/layers'
    }) {
        super(opts);
    }
}
export default LayerService;
//# sourceMappingURL=index.js.map